import Vue from 'vue';

// Register global directives before component imports
import TooltipDirective from './components/trust/trust_tooltip';
Vue.directive('tooltip', TooltipDirective);

import {
    ApckButton,
    ApckColWrapper,
    ApckColumn,
    ApckHelp,
    ApckLayout,
    ApckMainBody,
    ApckMainHeader,
    ApckMainNavBar,
    ApckMask,
    ApckPanel,
    ApckSep,
    ApckSpinner,
    ApckTable,
    ApckTitle,
    ApckTitleBar,
    ApckToggleButton,
    ApckToolbar,
    ApckVulnColumn,
    ApckVulnColumnNew,
    ApckLinkColumn,
    ApckBoolColumn,
    ApckCheckboxColumn,
    ApckCheckboxColumnNew,
    ApckDateColumn,
    ApckDateColumnNew,
    ApckUserColumn,
    ApckSubnetColumn,
    ApckPortsColumn,
    ApckAssetAddressColumn,
    ApckAssetTypeColumn,
    ApckLocationColumn,
    ApckScanProgressColumn,
    ApckScanProgressColumnNew,
    ApckTableRow,
    ApckAdminUserLinkColumn,
    ApckInternalHubColumn,
    ApckHealthColumn,
    ApckBadgeColumn,
    ApckDateYearsColumn,
    ApckDateOnlyColumn,
    ApckNotesColumn,
    ApckScanWarningsColumn,
    ApckLimitedTextColumn,
    ApckLicenceBandLimitColumn,
    ApckFloatRight,
    ApckPageBar,
} from "./main";
import { ApckContainerInfoColumn } from "./components/columns/container_info_column";
import {
    ApckBetweenTimeField,
    ApckCheckbox,
    ApckDateTimePicker,
    ApckField,
    ApckFieldButton,
    ApckFieldInfo,
    ApckGoScriptImport,
    ApckLorem,
    ApckMultiBetweenTimeField,
    ApckPassword,
    ApckSection,
    ApckSelect,
    ApckText,
    ApckTOTPField,
    ApckTextUpload,
    ApckFileUpload,
    ApckTagField,
    ApckFilterDateRange,
    ApckDropdownButton,
} from "./components/form";

import {ApckTab, ApckTabs, ApckTabDefer } from "./components/tabs";

import { ApckProgressBar } from './components/common/progress_bar';
import { ApckDashboardPortal, ApckSidePortal } from './components/dashboard/portal';
import { ApckPortlet } from './components/dashboard/portlet';
import { ApckGoScriptEditor } from './components/goscript/goscript';
import { ApckNewsAndUpdates } from './components/dashboard/news_and_updates_panel';
import { ApckAssetView } from './components/assets/asset_view';
import { ApckAssetDashboard, AssetSearchPanel } from './components/assets/asset_dashboard';
import { ApckAssetEventsSidebar } from './components/assets/asset_events';
import { ApckAssetAttackSurface } from './components/assets/asset_attack_surface';
import { ApckAssetBulkTable } from "./components/assets/asset_bulk_table";

import { ApckScanTable } from "./components/scans/scan_table";
import { ApckScanConfigSidebar } from './components/scans/sidebar';
import {
    ApckCredentialTitleColumn,
    CredentialManagerSSR,
    CredentialManagerTable
} from './components/credential_manager/cred_table';
import { CredentialManagerForm, CredentialManagerFormSSR } from "./components/credential_manager/cred_form";
import { ApckCredentialImport, ApckCredentialImportWrapper } from "./components/credential_manager/cred_import";

import { ApckScopeManagementForm } from './components/organisations/scope_management_form';
import { ApckIntegrationValidator } from './components/integrations/integrations_validate';
import { ApckAlertsPanel } from "./components/dashboard/alerts_and_notifications_panel";
import { ApckDashboardSidebar } from "./components/dashboard/ssr_dashboard";
import { ApckWhatsNewModal} from "./components/whats-new/whats-new-modal";

import { ApckTrustDashboard } from './components/trust/trust_dashboard';
import { ApckTrustRelationshipsTable } from './components/trust/trust_relationships';
import { ApckTrustDomainsTable } from './components/trust/trust_domains';
import { ApckTrustSettings } from './components/trust/trust_settings';
import { ApckTrustScopeManagement } from './components/trust/trust_scope';
import { ApckTrustThirdpartyDetails } from './components/trust/trust_thirdparty_details';
import { ApckTrustDomainDetails } from './components/trust/trust_domain_details';
import { ApckTrustRelationshipDetail } from './components/trust/trust_relationship_detail';
import { ApckTrustVulnerabilitiesTable } from './components/trust/trust_vulnerabilities';
import { ApckTrustCountriesTable } from './components/trust/trust_countries';
import { ApckTrustReporting } from './components/trust/trust_reporting';
import { ApckTrustSuppressionManagement, ApckQuickSuppressButton, ApckConvertToDomainButton } from './components/trust/trust_suppression';
import { ApckTrustEvents, ApckTrustEventsSidebar } from './components/trust/trust_events';
import { ApckTrustScans } from './components/trust/trust_scans';
import { ApckAdminTrustScans } from './components/admin/admin_trust_scans';
import { ApckAdminTrustSettings } from './components/admin/admin_trust_settings';
import { ApckAdminTrustReports } from './components/admin/admin_trust_reports';

import DiscoveredAssetsPage from "./views/asset-discovery/DiscoveredAssetsPage.vue";
import SuppressedAssetsPage from "./views/asset-discovery/SuppressedAssetsPage.vue";

import ActiveChecksDashboardPage from "./views/trust/ActiveChecksDashboardPage";
import ActiveChecksAddConfigPage from "./views/trust/ActiveChecksAddConfigPage";
import ActiveChecksEditConfigPage from "./views/trust/ActiveChecksEditConfigPage";
import ActiveChecksSingleResultsPage from "./views/trust/ActiveChecksSingleResultsPage";
import ActiveChecksAllResultsPage from "./views/trust/ActiveChecksAllResultsPage";
import ActiveChecksAuthPanel from "./components/trust/active-checks/auth/AuthPanel.vue";

import IntegrationsHubPage from './views/integrations/IntegrationsHubPage.vue'
import ScanReportGroupsPage from './views/scans/ScanReportGroupsPage.vue';
import UsersPage from './views/users/UsersPage.vue';
import UsersGroupsPage from './views/users/UsersGroupsPage.vue';
import UsersViewPage from "./views/users/UsersViewPage.vue";
import ApiScansPage from "./views/api-scans/ApiScansPage.vue";
import AssetsPage from "./views/assets/AssetsPage.vue";
import AssetGroupsPage from "./views/assets/AssetGroupsPage.vue";
import GoscriptsPage from "./views/goscripts/GoscriptsPage.vue";
import ApiTokensPage from "./views/api-tokens/ApiTokensPage.vue";
import TrashVulnerabilitiesPage from "./views/trash/TrashVulnerabilitiesPage.vue";
import TrashScansPage from "./views/trash/TrashScansPage.vue";
import TrashUsersPage from "./views/trash/TrashUsersPage.vue";
import ScanProfilesPage from "./views/scans/ScanProfilesPage.vue";
import NewScanPage from "./views/scans/NewScanPage.vue";
import DownloadsPage from "./views/DownloadsPage.vue";
import VulnsListPage from "./views/vulns/VulnsListPage.vue";
import ScanHubsPage from "./views/scans/ScanHubsPage.vue";
import OrgSettingsPage from "./views/organisation/OrgSettingsPage.vue";
import VulnDetailsPage from "./views/vulns/VulnDetailsPage.vue";
import VulnTable from "./components/vulns/table/VulnTable.vue";
import DashboardPage from "./views/DashboardPage.vue";
import WizardPage from "./views/WizardPage.vue";

// components shared by the SPA and Auth portal Vue apps
export const GlobalComponents = /*#__PURE__*/ {
    'apck-goscripteditor': ApckGoScriptEditor,
    'apck-asset-view': ApckAssetView,
    'apck-asset-dashboard': ApckAssetDashboard,
    'apck-asset-search': AssetSearchPanel,
    'apck-asset-events': ApckAssetEventsSidebar,
    'apck-asset-attack-surface': ApckAssetAttackSurface,
    'apck-scans-config-sidebar': ApckScanConfigSidebar,
    'apck-trust-dashboard': ApckTrustDashboard,
    'apck-trust-relationships': ApckTrustRelationshipsTable,
    'apck-trust-domains': ApckTrustDomainsTable,
    'apck-trust-thirdparty-details': ApckTrustThirdpartyDetails,
    'apck-trust-domain-details': ApckTrustDomainDetails,
    'apck-trust-relationship-detail': ApckTrustRelationshipDetail,
    'apck-trust-vulnerability-table': ApckTrustVulnerabilitiesTable,
    'apck-trust-countries-table': ApckTrustCountriesTable,
    'apck-trust-reporting': ApckTrustReporting,
    'apck-trust-settings': ApckTrustSettings,
    'apck-trust-scope-management': ApckTrustScopeManagement,
    'apck-trust-suppression-management': ApckTrustSuppressionManagement,
    'apck-quick-suppress-button': ApckQuickSuppressButton,
    'apck-convert-to-domain-button': ApckConvertToDomainButton,
    'apck-trust-events': ApckTrustEvents,
    'apck-trust-events-sidebar': ApckTrustEventsSidebar,
    'apck-trust-scans': ApckTrustScans,
    'apck-admin-trust-scans': ApckAdminTrustScans,
    'apck-admin-trust-settings': ApckAdminTrustSettings,
    'apck-admin-trust-reports': ApckAdminTrustReports,
    'apck-main-header': ApckMainHeader,
    'apck-main-nav-bar': ApckMainNavBar,
    'apck-main-body': ApckMainBody,
    'apck-help': ApckHelp,
    'apck-layout': ApckLayout,
    'apck-field': ApckField,
    'apck-field-info': ApckFieldInfo,
    'apck-password': ApckPassword,
    'apck-select': ApckSelect,
    'apck-filter-date-range': ApckFilterDateRange,
    'apck-dropdown-button': ApckDropdownButton,
    'apck-text': ApckText,
    'apck-totp-field': ApckTOTPField,
    'apck-checkbox': ApckCheckbox,
    'apck-button': ApckButton,
    'apck-toggle-button': ApckToggleButton,
    'apck-sep': ApckSep,
    'apck-title': ApckTitle,
    'apck-spinner': ApckSpinner,
    'apck-progress-bar': ApckProgressBar,
    'apck-float-right': ApckFloatRight,
    'apck-scope-management-form': ApckScopeManagementForm,
    'apck-integrations-validator': ApckIntegrationValidator,
    'apck-whats-new-modal':ApckWhatsNewModal,
    'apck-dashboard-portal': ApckDashboardPortal,
    'apck-side-portal': ApckSidePortal,
}

// components used by only the SPA Vue app
export const GlobalSPAComponents = /*#__PURE__*/ {
    ...GlobalComponents,
    'apck-col-wrapper': ApckColWrapper,
    'apck-toolbar': ApckToolbar,
    'apck-pagebar': ApckPageBar,
    'apck-titlebar': ApckTitleBar,
    'apck-panel': ApckPanel,
    'apck-mask': ApckMask,
    'apck-table': ApckTable,
    'apck-section': ApckSection,
    'apck-tab': ApckTab,
    'apck-tabs': ApckTabs,
    'apck-d-tab': ApckTabDefer,
    'apck-field-button': ApckFieldButton,
    'apck-lorem': ApckLorem,
    'apck-goscript-import': ApckGoScriptImport,
    'apck-text-upload': ApckTextUpload,
    'apck-file-upload': ApckFileUpload,
    'apck-betweentimefield': ApckBetweenTimeField,
    'apck-multibetweentimefield': ApckMultiBetweenTimeField,
    'apck-datetimepicker': ApckDateTimePicker,
    'apck-column': ApckColumn,
    'apck-vulncolumn': ApckVulnColumn,
    'apck-vulncolumnnew': ApckVulnColumnNew,
    'apck-linkcolumn': ApckLinkColumn,
    'apck-boolcolumn': ApckBoolColumn,
    'apck-healthcolumn': ApckHealthColumn,
    'apck-badgecolumn': ApckBadgeColumn,
    'apck-licencebandlimitrow': ApckLicenceBandLimitColumn,
    'apck-checkboxcolumn': ApckCheckboxColumn,
    'apck-checkboxcolumnnew': ApckCheckboxColumnNew,
    'apck-datecolumn': ApckDateColumn,
    'apck-datecolumnnew': ApckDateColumnNew,
    'apck-dateyearscolumn': ApckDateYearsColumn,
    'apck-dateonlycolumn': ApckDateOnlyColumn,
    'apck-usercolumn': ApckUserColumn,
    'apck-subnetcolumn': ApckSubnetColumn,
    'apck-portscolumn': ApckPortsColumn,
    'apck-assetaddresscolumn': ApckAssetAddressColumn,
    'apck-assettypecolumn': ApckAssetTypeColumn,
    'apck-locationcolumn': ApckLocationColumn,
    'apck-notescolumn': ApckNotesColumn,
    'apck-scanwarningscolumn': ApckScanWarningsColumn,
    'apck-limitedtextcolumn': ApckLimitedTextColumn,
    'apck-adminuserlinkcolumn': ApckAdminUserLinkColumn,
    'apck-scanprogresscolumn': ApckScanProgressColumn,
    'apck-scanprogresscolumnnew': ApckScanProgressColumnNew,
    'apck-internalhubcolumn': ApckInternalHubColumn,
    'apck-containerinfocolumn': ApckContainerInfoColumn,
    'apck-table-row': ApckTableRow,
    'apck-portlet': ApckPortlet,
    'apck-tag-field': ApckTagField,
    'apck-alerts-panel': ApckAlertsPanel,
    'apck-news-and-updates': ApckNewsAndUpdates,
    'apck-dashboard-sidebar': ApckDashboardSidebar,
    'apck-cred-man-page': CredentialManagerSSR,
    'apck-cred-man-table': CredentialManagerTable,
    'apck-cred-man-form': CredentialManagerForm,
    'apck-cred-man-form-ssr': CredentialManagerFormSSR,
    'apck-credential-import': ApckCredentialImport,
    'apck-credential-import-wrapper': ApckCredentialImportWrapper,
    'apck-credtitlecolumn': ApckCredentialTitleColumn,
    'apck-asset-bulk-table': ApckAssetBulkTable,
    'apck-whats-new-modal':ApckWhatsNewModal,
    'apck-discovered-assets-page': DiscoveredAssetsPage,
    'apck-suppressed-assets-page': SuppressedAssetsPage,
    'apck-scantable': ApckScanTable,
    'apck-active-checks-dashboard-page': ActiveChecksDashboardPage,
    'apck-active-checks-single-results-page': ActiveChecksSingleResultsPage,
    'apck-active-checks-all-results-page': ActiveChecksAllResultsPage,
    'apck-active-checks-edit-config-page': ActiveChecksEditConfigPage,
    'apck-active-checks-auth-panel': ActiveChecksAuthPanel,
    'apck-active-checks-add-config-page': ActiveChecksAddConfigPage,
    'apck-integrations-hub': IntegrationsHubPage,
    'apck-scan-report-groups-page': ScanReportGroupsPage,
    'apck-users-page': UsersPage,
    'apck-users-groups-page': UsersGroupsPage,
    'apck-users-view-page': UsersViewPage,
    'apck-api-scans-page': ApiScansPage,
    'apck-assets-page': AssetsPage,
    'apck-asset-groups-page': AssetGroupsPage,
    'apck-goscripts-page': GoscriptsPage,
    'apck-api-tokens-page': ApiTokensPage,
    'apck-trash-vulnerabilities-page': TrashVulnerabilitiesPage,
    'apck-trash-scans-page': TrashScansPage,
    'apck-trash-users-page': TrashUsersPage,
    'apck-scan-profiles-page': ScanProfilesPage,
    'apck-new-scan-page': NewScanPage,
    'apck-downloads-page': DownloadsPage,
    'apck-vulns-list-page': VulnsListPage,
    'apck-scan-hubs-page': ScanHubsPage,
    'apck-org-settings-page': OrgSettingsPage,
    'apck-vuln-details-page': VulnDetailsPage,
    'apck-new-vuln-table': VulnTable,
    'apck-dashboard-page': DashboardPage,
    'apck-wizard-page': WizardPage,
}

export function RegisterGlobalComponents(mapping, vue = Vue) {
    Object.entries(mapping).forEach(([key, value]) => {
        vue.component(key, value);
    });
}

// Automatically register all Vue components in the _ui directory
export function RegisterUIComponents(Vue) {
    const componentsContext = require.context('./components/_ui', true, /\.vue$/)

    componentsContext.keys().forEach(fileName => {
        const componentConfig = componentsContext(fileName)
        const component = componentConfig.default || componentConfig

        if (!component.name) {
            console.warn(`Component missing name: ${fileName}`)
            return
        }

        Vue.component(component.name, component)
    })
}
